module.exports = __webpack_public_path__ + "assets/logo_footer_old1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_footer_old1.jpg
 ** module id = 223
 ** module chunks = 1
 **/